import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, HostBinding } from '@angular/core';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Subscription } from 'rxjs';
import { ImageViewerService } from '../common/components/image.viewer/image.viewer.service';
import { EmptyObject, WebUtils } from '../common/utils';
import { AccessUtils, SpaceFacilityFee, TLocation } from '../core/entities';
import { FullWidthCarouselComponent } from '../core/fixed.carousel.component';
import { FixedCarouselItemDirective } from '../core/fixed.carousel.item.directive';
import { SiteLangMixin } from '../core/lang';
import { SitePathMixin } from '../core/site.path.utils';
import { SessionService } from '../session.service';
import { TSpaceBase } from '../thinkdesks/thinkdesks.entities';
import { MapService } from './map.service';
import { SpaceCard } from './space.card';

@Component({
  selector: 'app-location-page',
  standalone: true,
  imports: [
    CommonModule,
    GoogleMapsModule,
    RouterLink,
    SpaceCard,
    FontAwesomeModule,
    FullWidthCarouselComponent,
    FixedCarouselItemDirective,
  ],
  templateUrl: './location.page.html',
})
export class LocationPage extends SiteLangMixin(SitePathMixin(EmptyObject)) {
  @HostBinding('class') css = 'max-scroll';
  _common = _common;
  susbcription: Subscription;
  id: number;

  imageIndex = 0;
  object: TLocation;
  description: SafeHtml;
  position: any;
  options: {};

  openingHours: string[] = [];

  authCode: string;
  source: string;
  fees = SpaceFacilityFee;
  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private snackBar: MatSnackBar,
    private router: Router,
    public override session: SessionService,
    public mapService: MapService,
    private imageViewer: ImageViewerService
  ) {
    super();
  }
  ngOnInit() {
    this.mapService.loadMap();
    this.susbcription = this.route.paramMap.subscribe((result) => {
      this.id = parseInt(result.get('id'));
      this.refresh();
    });
    let authCode = this.route.snapshot.queryParamMap.get('authCode');
    this.authCode = authCode;
    let source = this.route.snapshot.queryParamMap.get('source');
    this.source = source;
    if (authCode) {
      if (source == 'app')
        this.session.embedded = true;
      WebUtils.web_result(
        this.http.post('/vp-validate', { authCode }),
        (result) => {
          let member = result;
          // this.snackBar.open(JSON.stringify(result));

          this.session.refresh();
        },
        this.snackBar,
        (error) => {
          this.router.navigate(['/sso-error']);
        }
      );
    }
  }

  ngOnDestroy() {
    this.session.setTitle();
  }
  showImage(index: number) {
    this.imageViewer.show({
      object: this.object,
      curIndex: index,
      numImages: this.object.images.length,
      pathFunc: (o: TLocation, index: number) => {
        let i = o.images[index];
        return this.locationImage(this.object, i);
      },
    });
  }
  activeSpaces: TSpaceBase[] = [];
  refresh() {
    WebUtils.web_result(
      this.http.get(`/api/public/location/${this.id}`),
      (result) => {
        this.object = result as TLocation;
        AccessUtils.fixLocation(this.object);
        this.activeSpaces = this.object.spaces.filter((s) => s.active);

        if (!this.object.active) {
          this.router.navigate(['/notfound']);
          return;
        }
        this.session.setTitle(this.object.name);

        this.description = this.sanitizer.bypassSecurityTrustHtml(
          this.lang(this.object.description ?? '', this.object.description_lang)
        );
        this.position = {
          lat: this.object.lat,
          lng: this.object.lng,
        };
        this.options = {
          title: this.object.name,
        };
        let s = this.lang(
          this.object?.openingHours,
          this.object?.openingHours_lang
        );
        this.openingHours = s.split('\n');
      },
      null,
      (err) => {
        this.router.navigate(['/notfound']);
      }
    );
  }
  openGoogleMap() {
    window.open(this.object.googleMapUrl);
  }
}
